import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "smart-webcomponents-react/source/styles/smart.default.css";
import { PostHogProvider } from "posthog-js/react";
import { posthogHost, posthogKey } from "./Environment.ts";
import "./i18n/config";
import {
  ErrorFallback,
} from "./components/common/ErrorFallback.tsx";
import { ErrorBoundary } from "react-error-boundary";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        window.location.reload();
      }}
    >
      <PostHogProvider apiKey={posthogKey} options={{ api_host: posthogHost }}>
        <App />
      </PostHogProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
